import { render, staticRenderFns } from "./RubricPurInBillList.vue?vue&type=template&id=73aceb69&scoped=true&"
import script from "./RubricPurInBillList.vue?vue&type=script&lang=js&"
export * from "./RubricPurInBillList.vue?vue&type=script&lang=js&"
import style0 from "./RubricPurInBillList.vue?vue&type=style&index=0&id=73aceb69&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73aceb69",
  null
  
)

export default component.exports